import { z } from 'zod';

export const GetOrderPaymentSettingsRequestSchema = z.object({
    orderId: z.string().uuid(),
});
